export class UploadBuildingDocumentPhoto {
  id: string;
  buildingId: string;
  photoData: string;
  mimeType: string;

  constructor(
    id: string,
    buildingId: string,
    photoData: string,
    mimeType: string
  ) {
    this.id = id;
    this.buildingId = buildingId;
    this.photoData = photoData;
    this.mimeType = mimeType;
  }
}
